import React from "react";

export const HowFoundList = ({ register, errors }) => {
    const howFoundUsList = [];
    return <div className="form-group">
        <label>How did you hear about us?</label>
        <select
            className="form-control"
            {...register("howFound", { required: "A selection is required" })}
        >
            <option value="">Please Select</option>
            {howFoundUsList.map((item) => (
                <option key={item.HowFoundID} value={item.HowFoundID}>
                    {item.DisplayText}
                </option>
            ))}
        </select>
        {errors.howFound && <div className="upsell-input-error">{errors.howFound.message}</div>}
    </div>;
};